"use client"

import { Button } from "./components/ui/button"
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "./components/ui/card"
import { Label } from "./components/ui/label"
import { Switch } from "./components/ui/switch"

export function CardsCookieSettings() {
  return (
    <Card>
      <CardHeader>
        <CardTitle>쿠키 설정</CardTitle>
        <CardDescription>쿠키 설정을 관리하세요.</CardDescription>
      </CardHeader>
      <CardContent className="grid gap-6">
        <div className="flex items-center justify-between gap-4">
          <Label htmlFor="necessary" className="flex flex-col items-start">
            <span>필수 쿠키</span>
            <span className="text-muted-foreground leading-snug font-normal">
              웹사이트 사용 및 기능 이용에 필수적인 쿠키입니다.
            </span>
          </Label>
          <Switch id="necessary" defaultChecked aria-label="필수" />
        </div>
        <div className="flex items-center justify-between gap-4">
          <Label htmlFor="functional" className="flex flex-col items-start">
            <span>기능 쿠키</span>
            <span className="text-muted-foreground leading-snug font-normal">
              개인화된 기능을 제공하기 위한 쿠키입니다.
            </span>
          </Label>
          <Switch id="functional" aria-label="기능" />
        </div>
      </CardContent>
      <CardFooter>
        <Button variant="outline" className="w-full bg-transparent">
          설정 저장
        </Button>
      </CardFooter>
    </Card>
  )
}
